import { render, staticRenderFns } from "./FindingsTypesLayout.vue?vue&type=template&id=7064b7d0"
import script from "./FindingsTypesLayout.vue?vue&type=script&lang=js"
export * from "./FindingsTypesLayout.vue?vue&type=script&lang=js"
import style0 from "./FindingsTypesLayout.vue?vue&type=style&index=0&id=7064b7d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports